/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-19 17:52:29
 */
import { Divider } from "antd";
import "./index.less";
export default function Footer() {
  return (
    <div className={"footer-box"}>
      <div className={"footer-webInfo"}>
        官方网站：www.mvwchina.com 客服电话：400-001-8080 010-84280076
        办公地址：北京市朝阳区芍药居38号楼3层
      </div>
      <Divider style={{ borderTop: "0.5px solid rgba(51, 51, 51, 0.1)" }} />
      <div className={"footer-record"}>
        医视界版权所有 京ICP备13033683号 京公网安备 11010502041560号
      </div>
    </div>
  );
}
